import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from './api.service';

export type RegexPatterns = { [key: string]: string };

@Injectable({
  providedIn: 'root',
})
export class RegexService {
  private readonly regex_subject = new BehaviorSubject<RegexPatterns>({});
  public readonly regex_observable: Observable<RegexPatterns> = this.regex_subject.asObservable();
  private initiated = false;

  private readonly api = inject(ApiService);

  constructor() {
    this.fetchRegex();
  }

  public getRegex(): RegexPatterns {
    return this.regex_subject.value;
  }

  public isInitiated(): boolean {
    return this.initiated;
  }

  private fetchRegex(): void {
    this.api.getRegex().subscribe((data: RegexPatterns) => {
      this.regex_subject.next(data);
      this.initiated = true;
    });
  }
}
